import React, { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { fetchWithCache } from '../../Utilities/cacheThunks';
import ViewClassComponent from '../ViewClassComponent/ViewClassComponent';
import axiosInstance from '../../Config/axiosConfig';
import { makeSelectCachedResource } from '../../Utilities/cacheSelectors';

function CategoryListView() {
  const dispatch = useDispatch();
  const listRef = useRef(null);
  const storageKey = 'topClassesCache';
  const cacheDuration = 60; // Cache duration in minutes
  
 // Create memoized selector instance
  const selectCachedTopClasses = useMemo(
    () => makeSelectCachedResource(storageKey),
    [storageKey]
  );

  const { data = [], loading, error } = useSelector(selectCachedTopClasses);

  useEffect(() => {
    const endpoint = 'public/get-top-four-classes-with-most-views';
    dispatch(fetchWithCache(
      storageKey,
      () => axiosInstance.get(endpoint),
      cacheDuration,
    ));
  }, [dispatch, storageKey, cacheDuration]);

  const WireframeLoader = () => (
    <div className="grid-container" aria-busy="true" aria-live="polite">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="wireframe-card">
          <div className="wireframe-image pulse-animation" />
          <div className="wireframe-line pulse-animation" style={{ width: '60%' }} />
          <div className="wireframe-line pulse-animation" style={{ width: '80%', animationDelay: '0.2s' }} />
          <div className="wireframe-line pulse-animation" style={{ width: '70%', animationDelay: '0.4s' }} />
        </div>
      ))}
    </div>
  );

   // Memoize the rendered class components
  const renderedClasses = useMemo(() => (
    <div className="grid-container" ref={listRef}>
      {data.map((category) => (
        <ViewClassComponent 
          key={category.id} 
          classData={category} 
        />
      ))}
    </div>
  ), [data]);

  return (
    <div className="category-grid-container">
      {loading ? (
        <WireframeLoader />
      ) : error && data.length === 0 ? (
        <p className="no-categories">Failed to load categories: {error}</p>
      ) : data.length > 0 ? (
        <div className="grid-container" ref={listRef}>
          {data.map((category) => (
            <ViewClassComponent key={category.id} classData={category} />
          ))}
        </div>
      ) : (
        <p className="no-categories">No categories available</p>
      )}
    </div>
  );
}

CategoryListView.propTypes = {
  // Add any props if your component receives them
};

export default CategoryListView;